import {
  createStore,
} from '@udecode/plate';

export const withErrorHandling = (editor) => {
  const errorStore = createErrorStore();
  editor.errorHandler = {
    errorStore,
    pushErrorMessage: (message) => {
      const error = { message };
      errorStore.set.pushError(error);
    },
    popErrorMessage: () => {
      errorStore.set.pop();
    },
  };

  return editor;
};

export const createErrorStore = () => {
  return createStore('error')({ errors: [] })
    .extendActions((set, get) => ({
      pushError: (error) => {
        const errors = get.errors();
        set.errors([ ...errors, error ]);
      },
    }))
    .extendActions((set, get) => ({
      pop: () => {
        const errors = get.errors();
        const errLen = errors.length;
        const newErrors = errors.slice(1, errLen);
        set.errors(newErrors);
      },
    }))
    .extendSelectors((state, get) => ({
      top: () => {
        const errors = get.errors();
        if (errors.length > 0) return errors[0];
        return null;
      },
    }));
};
